import { render, staticRenderFns } from "./returnDialogModule.vue?vue&type=template&id=fb955248&scoped=true"
import script from "./returnDialogModule.vue?vue&type=script&lang=js"
export * from "./returnDialogModule.vue?vue&type=script&lang=js"
import style0 from "./returnDialogModule.vue?vue&type=style&index=0&id=fb955248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb955248",
  null
  
)

export default component.exports